import React from "react";
import { Stack, Typography, TypographyProps } from "@mui/material";

import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

export interface ConfigContentRecapsProps {
  setting?: string;
  voice?: string;
  collection?: string;
  subtitles?: string;
  transfert?: string;
  color?: TypographyProps["color"];
  variant?: TypographyProps["variant"];
}

const ConfigContentRecaps: React.FC<ConfigContentRecapsProps> = (props) => {
  const { voice, setting, collection, subtitles, transfert, color = "text.secondary", variant = "body1" } = props;
  return (
    <>
      {setting && (
        <Stack display="inline-flex" direction="row" spacing={0.5} mr={1.5}>
          <SettingsOutlinedIcon fontSize="small" sx={{ color }} />
          <Typography variant={variant} color={color}>
            {setting}
          </Typography>
        </Stack>
      )}
      {voice && (
        <Stack display="inline-flex" direction="row" spacing={0.5} mr={1.5}>
          <VolumeUpOutlinedIcon fontSize="small" sx={{ color }} />
          <Typography variant={variant} color={color}>
            {voice}
          </Typography>
        </Stack>
      )}
      {collection && (
        <Stack display="inline-flex" direction="row" spacing={0.5} mr={1.5}>
          <VideoLibraryOutlinedIcon fontSize="small" sx={{ color }} />
          <Typography variant={variant} color={color}>
            {collection}
          </Typography>
        </Stack>
      )}
      {subtitles && (
        <Stack display="inline-flex" direction="row" spacing={0.5} mr={1.5}>
          <SubtitlesOutlinedIcon fontSize="small" sx={{ color }} />
          <Typography variant={variant} color={color}>
            {subtitles}
          </Typography>
        </Stack>
      )}
      {transfert && (
        <Stack display="inline-flex" direction="row" spacing={0.5} mr={1.5}>
          <Inventory2OutlinedIcon fontSize="small" sx={{ color }} />
          <Typography variant={variant} color={color}>
            {transfert}
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default ConfigContentRecaps;
